import React from "react";
import "./index.less";
import ResourceDetail from "../ResourceDetail";
import MenusAntd from "@/components/Menus/MenusAntd";
import { Empty } from "antd";

interface ResourceCategoryProps {
  // Define your props here
  menuContext: any;
  resourceDetail: any;
  resourceLoading: boolean;
}

const prefix = "resource-category";
const ResourceCategory: React.FC<ResourceCategoryProps> = (props) => {
  const {menuContext,resourceDetail,resourceLoading} = props;
  console.log("menuContext",menuContext,resourceDetail);
  return (
    <div className={`${prefix}-box`}>
      <aside>{menuContext?.items && menuContext?.items?.length > 0 && <MenusAntd menuConfig={menuContext} />}</aside>
      <section style={{flex: 1}}>
        {resourceDetail !== null ? (
          <ResourceDetail value={resourceDetail} />
        ) : (
          <div className="flex-center resource-empty">
            {!resourceLoading && <Empty className="common-antd-empty" image={<img src={require("@/assets/images/message/empty.png")} />} description="暂无数据" />}
          </div>
        )}
      </section>
    </div>
  );
};

export default React.memo(ResourceCategory);
